export const SET_ALL_CUSTOMERS = 'SET_ALL_CUSTOMERS';
export const DELETE_CUSTOMER = 'DELETE_CUSTOMER';
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';

export const setAllCustomers = (customers) => ({
  type: SET_ALL_CUSTOMERS,
  payload: customers,
});

export const deleteCustomerAction = (email) => ({
  type: DELETE_CUSTOMER,
  payload: email,
});

export const updateCustomer = (updatedCustomer) => ({
  type: UPDATE_CUSTOMER,
  payload: updatedCustomer,
});
